import { IStringTool } from "../core/IStringTool";
import { ISplitOptionItem } from "../models/text/ISplitOptionItem";
import { ISplitOptions } from "../models/text/ISplitOptions";
import { SplitOptionsParserInput } from "../models/text/SplitOptionsParserInput";

export class SplitOptionsParserTool implements IStringTool<SplitOptionsParserInput, ISplitOptions> {
  process({ attributeValue }: SplitOptionsParserInput): ISplitOptions {
    const options: ISplitOptions = {
      line: [],
      word: [],
      char: [],
      charLine: [],
      charWord: [],
      wordLine: [],
      fit: false,
    };

    if (!attributeValue) {
      return options;
    }

    const parts = attributeValue.split("|");

    parts.forEach((part) => {
      const trimmedPart = part.trim();
      if (!trimmedPart) return;

      const match = trimmedPart.match(/^(\w+-)?(\w+)(\[(.*?)\])?$/);

      if (match) {
        const prefix = match[1] || "";
        const optionType = match[2];
        const fullOptionKey = this.toCamelCase(prefix + optionType);
        const paramsString = match[4] || "";
        const params = paramsString
          .split(";")
          .map((p) => p.trim())
          .filter((p) => p.length > 0);

        const parsedParam: ISplitOptionItem = this.parseParamsArray(params);

        switch (fullOptionKey) {
          case "line":
            (options.line as ISplitOptionItem[]).push(parsedParam);
            break;
          case "word":
            (options.word as ISplitOptionItem[]).push(parsedParam);
            break;
          case "char":
            (options.char as ISplitOptionItem[]).push(parsedParam);
            break;
          case "charLine":
            (options.charLine as ISplitOptionItem[]).push(parsedParam);
            break;
          case "charWord":
            (options.charWord as ISplitOptionItem[]).push(parsedParam);
            break;
          case "wordLine":
            (options.wordLine as ISplitOptionItem[]).push(parsedParam);
            break;
          case "fit":
            options.fit = true;
            break;
          default:
            console.warn(
              `SplitOptionsParserTool: Unrecognized option type "${fullOptionKey}" in part "${trimmedPart}"`,
            );
            break;
        }
      } else {
        console.warn(`SplitOptionsParserTool: Could not parse part format "${trimmedPart}"`);
      }
    });

    return options;
  }

  private toCamelCase(str: string): string {
    return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
  }

  private parseParamsArray(params: string[]): ISplitOptionItem {
    const result: ISplitOptionItem = { align: "start" };

    params.forEach((param) => {
      if (param === "abs") {
        result.abs = true;
      } else if (param.startsWith("random")) {
        result.align = "random";
        const randomMatch = param.match(/random\(\s*(\d+)\s*,\s*(\d+)\s*\)/);
        if (randomMatch) {
          result.random = {
            min: parseInt(randomMatch[1], 10),
            max: parseInt(randomMatch[2], 10),
          };
        }
      } else if (["start", "center", "end"].includes(param)) {
        result.align = param;
      }
    });

    return result;
  }
}
